import { agentRoles } from "../constants/model";

const operatorEntitlement = Object.freeze({
  tabs: {
    showManageUsers: true,
    showManageAgents: false,
    showAuditLogs: true,
  },
  users: {
    canDelete: false,
    canBlock: false,
    canUnblock: false,
    canDeleteRefreshTokens: true,
    canRegenerateMfaRecoveryCode: true,
    canChangeEmail: false,
    canVerifyEmailAccess: true,
    canDeleteMfaEnrollments: true,
    canResetPassword: false,
    canPerformWildcardNameSearch: false,
    canBypassEmailVerification: true,
    canBypassMfa: false,
  },
  agents: { administrableRoles: [] },
});

const managerEntitlement = Object.freeze({
  tabs: {
    showManageUsers: true,
    showManageAgents: true,
    showAuditLogs: true,
  },
  users: {
    canDelete: true,
    canBlock: true,
    canUnblock: true,
    canDeleteRefreshTokens: true,
    canRegenerateMfaRecoveryCode: true,
    canChangeEmail: true,
    canVerifyEmailAccess: true,
    canDeleteMfaEnrollments: true,
    canResetPassword: false,
    canPerformWildcardNameSearch: true,
    canBypassEmailVerification: true,
    canBypassMfa: false,
  },
  agents: {
    administrableRoles: [agentRoles.operator.value],
  },
});

const adminEntitlement = Object.freeze({
  tabs: {
    showManageUsers: true,
    showManageAgents: true,
    showAuditLogs: true,
  },
  users: {
    canDelete: true,
    canBlock: true,
    canUnblock: true,
    canDeleteRefreshTokens: true,
    canRegenerateMfaRecoveryCode: true,
    canChangeEmail: true,
    canVerifyEmailAccess: true,
    canDeleteMfaEnrollments: true,
    canResetPassword: false,
    canPerformWildcardNameSearch: true,
    canBypassEmailVerification: true,
    canBypassMfa: true,
  },
  agents: {
    administrableRoles: [
      agentRoles.operator.value,
      agentRoles.manager.value,
      agentRoles.admin.value,
    ],
  },
});

const roleEntitlementMap = Object.freeze([
  { agentRole: agentRoles.operator.value, entitlement: operatorEntitlement },
  { agentRole: agentRoles.manager.value, entitlement: managerEntitlement },
  { agentRole: agentRoles.admin.value, entitlement: adminEntitlement },
]);

const getAgentEntitlement = (role) => {
  const sanitizedRole = role && role.length > 0 ? role.trim() : "";
  return sanitizedRole.length === 0
    ? null
    : roleEntitlementMap.find((map) => map.agentRole === sanitizedRole)
        ?.entitlement;
};

const findRolesWithEntitlement = (entitlementFilter) => {
  if (!entitlementFilter || typeof entitlementFilter !== "function")
    return null;

  const matches = roleEntitlementMap.filter((entitlementMap) => {
    return entitlementFilter(entitlementMap.entitlement);
  });

  return matches && matches.length > 0
    ? matches.map((match) => {
        return match.agentRole;
      })
    : null;
};

export { getAgentEntitlement, findRolesWithEntitlement };
